<div class="threedotloader">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</div>